import { gql } from '@grandvisionhq/graphql';
import { paymentResponse } from '../fragments/payment-response.js';
import { placeOrderMutationFailurePreOrderCreationResponse, placeOrderMutationFailurePostOrderCreationResponse, placeOrderMutationFailureRecalculatedCartResponse } from '../fragments/place-order-mutation-failure.js';

const PLACE_ORDER = gql`
  mutation PlaceOrder($placeOrderInput: PlaceOrderInput!) {
    placeOrder(placeOrderInput: $placeOrderInput) {
      ...PaymentResponseFragment
      ...PlaceOrderMutationFailurePreOrderCreationResponseFragment
      ...PlaceOrderMutationFailurePostOrderCreationResponseFragment
      ...placeOrderMutationFailureRecalculatedCartResponseFragment
    }
  }
  ${paymentResponse}
  ${placeOrderMutationFailurePreOrderCreationResponse}
  ${placeOrderMutationFailurePostOrderCreationResponse}
  ${placeOrderMutationFailureRecalculatedCartResponse}
`;

export { PLACE_ORDER };
//# sourceMappingURL=place-order.js.map
